import { render, staticRenderFns } from "./RecentSubscribeSwiper.vue?vue&type=template&id=31246228"
import script from "./RecentSubscribeSwiper.vue?vue&type=script&lang=js"
export * from "./RecentSubscribeSwiper.vue?vue&type=script&lang=js"
import style0 from "./RecentSubscribeSwiper.vue?vue&type=style&index=0&id=31246228&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports